import { QuoteRulesetsService } from "@common/client"
import { makeAxiosMutation, makeQuery } from "../utils"

const RULESET_PAGE_SIZE = 500

const VERSION_HISTORY_SIZE = 100

export const rulesetsBaseKey = ["quote-rulesets"] as const

export const rulesetsKey = (search: string) =>
  [...rulesetsBaseKey, "list", { search }] as const

export const rulesetKey = (rulesetId: string) =>
  [...rulesetsBaseKey, "detail", rulesetId] as const

export const rulesetVersionsKey = (rulesetId: string) =>
  [...rulesetsBaseKey, "versions", rulesetId] as const

export const rulesetsQuery = makeQuery({
  serviceCall: ({ search }: { search: string }) =>
    QuoteRulesetsService.listRulesets({
      search: search || null,
      limit: RULESET_PAGE_SIZE,
    }),
  queryKey: ({ search }) => rulesetsKey(search),
})

export const rulesetQuery = makeQuery({
  serviceCall: QuoteRulesetsService.get,
  queryKey: ({ ruleset_id }) => rulesetKey(ruleset_id),
})

export const rulesetVersionsQuery = makeQuery({
  serviceCall: ({ ruleset_id }: { ruleset_id: string }) =>
    QuoteRulesetsService.listVersions({
      ruleset_id,
      limit: VERSION_HISTORY_SIZE,
    }),
  queryKey: ({ ruleset_id }) => rulesetVersionsKey(ruleset_id),
})

export const useCreateRulesetMutation = makeAxiosMutation({
  serviceCall: QuoteRulesetsService.create,
  invalidates: () => [rulesetsBaseKey],
})

export const useUpdateRulesetMutation = makeAxiosMutation({
  serviceCall: QuoteRulesetsService.update,
  invalidates: () => [rulesetsBaseKey],
})

export const useCreateRulesetVersionMutation = makeAxiosMutation({
  serviceCall: QuoteRulesetsService.createVersion,
  invalidates: () => [rulesetsBaseKey],
})
